(function () {
  var NS = 'http://www.w3.org/2000/svg';
  function element(tag, attributes, text) {
    var node = document.createElementNS(NS, tag);
    Object.entries(attributes || {}).forEach(function (entry) { node.setAttribute(entry[0], entry[1]); });
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      var image = new Image(); image.crossOrigin = 'anonymous';
      image.onload = function () { resolve(image); }; image.onerror = reject; image.src = url;
    });
  }
  function init() {
    document.querySelectorAll('[data-holiday-preview]').forEach(function (preview) {
      if (preview.dataset.initialized) return;
      preview.dataset.initialized = 'true';
      var root = preview.closest('[data-section-type="product"]'), form = preview.closest('form');
      var button = preview.querySelector('[data-holiday-generate]'), status = preview.querySelector('[data-holiday-preview-status]');
      var back = preview.querySelector('[data-holiday-back]'), fileInput = preview.querySelector('[data-holiday-preview-file]');
      function labelUpload() {
        var upload = form.querySelector('input[type="file"]:not([data-holiday-preview-file])');
        if (!upload) return;
        var browse = upload.closest('label');
        if (!browse || browse.parentElement.querySelector('[data-holiday-upload-note]')) return;
        var note = document.createElement('span');
        note.setAttribute('data-holiday-upload-note', '');
        note.textContent = preview.dataset.uploadNote;
        note.style.cssText = 'display:inline-block;font-size:13px;margin:0 12px 6px 0;color:#333';
        browse.insertAdjacentElement('afterend', note);
      }
      var zoomDialog = preview.querySelector('[data-holiday-zoom-dialog]');
      var zoomContent = zoomDialog.querySelector('[data-holiday-zoom-content]');
      var previousOverflow;
      preview.querySelectorAll('[data-holiday-zoom]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var card = trigger.querySelector('[data-holiday-front]') || trigger.querySelector('svg,img');
          if (!card) return;
          zoomContent.replaceChildren(card.cloneNode(true));
          previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          zoomDialog.showModal();
        });
      });
      zoomDialog.querySelector('[data-holiday-zoom-close]').addEventListener('click', function () { zoomDialog.close(); });
      zoomDialog.addEventListener('click', function (event) {
        if (event.target !== zoomDialog) return;
        var bounds = zoomDialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) zoomDialog.close();
      });
      zoomDialog.addEventListener('close', function () { document.body.style.overflow = previousOverflow; zoomContent.replaceChildren(); });
      labelUpload();
      new MutationObserver(labelUpload).observe(form, {childList:true,subtree:true});
      var generated = false, revision = 0, busy = false, selectedArtwork = null, artworkWarning = '';
      var artPromise = loadImage(preview.dataset.artUrl).then(function (image) {
        var canvas = document.createElement('canvas'); canvas.width = image.naturalWidth; canvas.height = image.naturalHeight;
        canvas.getContext('2d').drawImage(image, 0, 0); return canvas.toDataURL('image/png');
      });
      function read(name) { var field = form.elements.namedItem('properties[' + name + ']'); return field ? field.value.trim() : ''; }
      function message() {
        var choice = form.querySelector('[data-holiday-message-choice]');
        return choice && choice.selectedIndex > 0 ? choice.selectedOptions[0].dataset.message : read('Message');
      }
      function dimensions() {
        var selector = root.querySelector('[id^="SingleOptionSelector-"]'), size = selector ? selector.value : '';
        var dimensions = /^A2/.test(size) ? [4.25, 5.5] : /^A6/.test(size) ? [4.5, 6.125] : [5, 7];
        return preview.dataset.horizontal === 'true' ? dimensions.reverse() : dimensions;
      }
      function clearFile() {
        fileInput.value = '';
      }
      function edited(event) {
        if (event.target === fileInput || event.target.hasAttribute('data-holiday-finish-toggle') || !event.target.matches('input,textarea,select')) return;
        if (event.target.type === 'file') selectedArtwork = event.target.files[0] || null;
        revision++; generated = false; clearFile(); button.hidden = false;
        preview.dataset.stale = String(back.children.length > 0); status.textContent = preview.dataset.pending;
      }
      form.addEventListener('input', edited, true); form.addEventListener('change', edited, true);
      function textBlock(svg, value, y, maxWidth, fontSize, minSize, maxHeight, family, weight) {
        var measure = document.createElement('canvas').getContext('2d'), lines;
        function wrap(size) {
          measure.font = (weight || 'normal') + ' ' + size + 'px ' + family;
          var result = [];
          value.split(/\r?\n/).forEach(function (paragraph) {
            if (!paragraph.trim()) { result.push(''); return; }
            var line = '';
            paragraph.trim().split(/\s+/).forEach(function (word) {
              if (measure.measureText(word).width > maxWidth) {
                if (line) { result.push(line); line = ''; }
                var part = '';
                Array.from(word).forEach(function (letter) {
                  if (part && measure.measureText(part + letter).width > maxWidth) { result.push(part); part = ''; }
                  part += letter;
                }); line = part; return;
              }
              if (line && measure.measureText(line + ' ' + word).width > maxWidth) { result.push(line); line = word; }
              else line += (line ? ' ' : '') + word;
            }); result.push(line);
          }); return result;
        }
        for (; fontSize >= minSize; fontSize--) { lines = wrap(fontSize); if (lines.length * fontSize * 1.4 <= maxHeight) break; }
        if (fontSize < minSize) throw new Error('message-fit');
        var text = element('text', {x:350,y:y,'text-anchor':'middle',fill:'#242424','font-family':family,'font-size':fontSize,'font-weight':weight || 'normal'});
        lines.forEach(function (line, i) { text.appendChild(element('tspan', {x:350,dy:i ? fontSize * 1.4 : 0}, line)); });
        svg.appendChild(text);
      }
      async function logoData() {
        var inputs = Array.from(form.querySelectorAll('input[type="file"]:not([data-holiday-preview-file])'));
        var input = inputs.find(function (field) { return field.files && field.files.length; });
        var file = selectedArtwork || (input && input.files[0]);
        if (!file) return null;
        if (!/\.(png|jpe?g|webp|gif|svg|bmp)$/i.test(file.name) && !/^image\/(png|jpeg|webp|gif|svg\+xml|bmp)$/i.test(file.type)) throw new Error('artwork-format');
        if (file.size > 20 * 1024 * 1024) throw new Error('artwork-size');
        var url = URL.createObjectURL(file), image;
        try { image = await loadImage(url); } catch (error) { throw new Error('artwork-read'); }
        finally { URL.revokeObjectURL(url); }
        var canvas = document.createElement('canvas');
        var scale = Math.min(1, 1200 / Math.max(image.naturalWidth, image.naturalHeight));
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale)); canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        try {
          canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
          return {url:canvas.toDataURL('image/png'),width:canvas.width,height:canvas.height};
        } catch (error) { throw new Error('artwork-read'); }
      }
      async function draw(sample) {
        var size = dimensions(), height = 700 * size[1] / size[0], folded = preview.dataset.folded === 'true', horizontal = preview.dataset.horizontal === 'true';
        var fullWidth = folded && !horizontal ? 1400 : 700, fullHeight = folded && horizontal ? height * 2 : height;
        var svg = element('svg', {xmlns:NS,viewBox:'0 0 ' + fullWidth + ' ' + fullHeight,width:(size[0] * (folded && !horizontal ? 2 : 1))+'in',height:(size[1] * (folded && horizontal ? 2 : 1))+'in',role:'img','aria-label':preview.dataset.backLabel});
        var art = await artPromise;
        function background(target, x, y) {
          if (horizontal) target.appendChild(element('image', {href:art,width:height,height:700,transform:'translate('+(x+700)+' '+y+') rotate(90)',preserveAspectRatio:'none'}));
          else target.appendChild(element('image', {href:art,x:x,y:y,width:700,height:height,preserveAspectRatio:'none'}));
        }
        if (folded) {
          svg.appendChild(element('rect', {width:fullWidth,height:fullHeight,fill:'#fff'}));
          var defs = element('defs');
          var topClip = element('clipPath',{id:'holiday-corner-top'}), bottomClip = element('clipPath',{id:'holiday-corner-bottom'});
          topClip.appendChild(element('rect',{width:350,height:height/2}));
          bottomClip.appendChild(element('rect',{x:fullWidth-350,y:fullHeight-height/2,width:350,height:height/2}));
          defs.appendChild(topClip); defs.appendChild(bottomClip); svg.appendChild(defs);
          var topArt=element('g',{'clip-path':'url(#holiday-corner-top)'}), bottomArt=element('g',{'clip-path':'url(#holiday-corner-bottom)'});
          if (horizontal) {
            topArt.appendChild(element('image',{href:art,width:700,height:height,preserveAspectRatio:'none'}));
            bottomArt.appendChild(element('image',{href:art,x:0,y:height,width:700,height:height,preserveAspectRatio:'none'}));
          } else { background(topArt,0,0); background(bottomArt,700,0); }
          svg.appendChild(topArt); svg.appendChild(bottomArt);
        } else background(svg,0,0);
        var content = element('g',{transform:folded ? 'translate('+(horizontal ? 0 : 700)+' '+(horizontal ? height : 0)+')' : 'translate(0 0)'}); svg.appendChild(content);
        var logo = null;
        if (!sample) {
          artworkWarning = '';
          try { logo = await logoData(); }
          catch (error) {
            if (!/^artwork-/.test(error.message)) throw error;
            artworkWarning = error.message === 'artwork-format' ? preview.dataset.artworkFormat : error.message === 'artwork-size' ? preview.dataset.artworkSize : preview.dataset.artworkRead;
          }
        }
        var greeting = message() || (sample ? preview.dataset.sample : '');
        textBlock(content, greeting, height * (logo ? (horizontal ? .22 : .26) : .33), 490, 32, horizontal ? 14 : 18, height * (logo && !horizontal ? .23 : .27), 'Georgia, serif');
        content.appendChild(element('path', {d:'M 315 '+height*(logo ? .71 : .64)+' H 385',stroke:'#9c9c9c','stroke-width':1}));
        var identity = [read('Your Name'),read('Company Name')].filter(Boolean).join('\n');
        var contacts = [[read('Address Line 1'),read('Address Line 2')].filter(Boolean).join(', '),[read('Phone Number'),read('Email')].filter(Boolean).join('  ·  ')].filter(Boolean).join('\n');
        textBlock(content, identity, height * (logo ? .76 : .71), 490, 24, horizontal ? 14 : 18, height * .09, 'Arial, sans-serif', 'bold');
        textBlock(content, contacts, height * (logo ? .86 : .81), 490, 20, horizontal ? 14 : 18, height * .10, 'Arial, sans-serif');
        if (logo) {
          var scale = Math.min(170 / logo.width, height * .18 / logo.height), w = logo.width * scale, h = logo.height * scale;
          content.appendChild(element('image', {href:logo.url,x:350-w/2,y:height*.60-h/2,width:w,height:h}));
        }
        if (folded) {
          var guide = element('g',{'data-fold-guide':''});
          guide.appendChild(element('path',{d:horizontal ? 'M 0 '+height+' H 700' : 'M 700 0 V '+height,stroke:'#aaa','stroke-dasharray':'8 8'}));
          guide.appendChild(element('text',{x:horizontal ? 350 : 700,y:horizontal ? height-10 : 26,'text-anchor':'middle','font-family':'Arial,sans-serif','font-size':18,fill:'#777'},preview.dataset.foldLabel));
          svg.appendChild(guide);
        }
        return svg;
      }
      button.addEventListener('click', async function () {
        if (busy) return;
        var fields = Array.from(form.querySelectorAll('input,textarea,select')), invalid = fields.find(function (field) { return !field.checkValidity(); });
        if (invalid) { invalid.reportValidity(); return; }
        busy = true; button.disabled = true;
        var currentRevision = revision;
        try {
          if (document.fonts) await document.fonts.ready;
          var messageField = form.elements.namedItem('properties[Message]');
          if (messageField) messageField.value = message();
          var svg = await draw(false), printSVG = svg.cloneNode(true);
          printSVG.querySelectorAll('[data-fold-guide]').forEach(function (guide) { guide.remove(); });
          var source = new XMLSerializer().serializeToString(printSVG);
          var svgURL = URL.createObjectURL(new Blob([source], {type:'image/svg+xml'}));
          var image;
          try { image = await loadImage(svgURL); } finally { URL.revokeObjectURL(svgURL); }
          var size = dimensions(), canvas = document.createElement('canvas');
          canvas.width = Math.round(size[0] * 300 * (preview.dataset.folded === 'true' && preview.dataset.horizontal !== 'true' ? 2 : 1)); canvas.height = Math.round(size[1] * 300 * (preview.dataset.folded === 'true' && preview.dataset.horizontal === 'true' ? 2 : 1));
          canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
          var blob = await new Promise(function (resolve) { canvas.toBlob(resolve, 'image/png'); });
          if (!blob) throw new Error('export');
          if (currentRevision !== revision) return;
          var transfer = new DataTransfer(); transfer.items.add(new File([blob], preview.dataset.productCode + '-holiday-preview.png', {type:'image/png'}));
          fileInput.files = transfer.files;
          back.replaceChildren(svg); generated = true; preview.dataset.stale = 'false';
          status.textContent = preview.dataset.ready + (artworkWarning ? ' ' + artworkWarning : '');
        } catch (error) { clearFile(); status.textContent = error.message === 'artwork-format' ? preview.dataset.artworkFormat : error.message === 'artwork-size' ? preview.dataset.artworkSize : error.message === 'artwork-read' ? preview.dataset.artworkRead : preview.dataset.error; }
        finally { busy = false; button.disabled = false; button.hidden = generated; }
      });
      form.addEventListener('submit', function (event) {
        if (!generated || !fileInput.files.length) return;
        event.preventDefault(); event.stopImmediatePropagation();
        var messageField = form.elements.namedItem('properties[Message]');
        if (messageField) messageField.value = message();
        HTMLFormElement.prototype.submit.call(form);
      }, true);
      var cart = form.querySelector('[name="add"]');
      if (cart) {
        cart.disabled = false;
        new MutationObserver(function () { if (cart.disabled) cart.disabled = false; }).observe(cart, {attributes:true,attributeFilter:['disabled']});
      }
      draw(true).then(function (svg) { if (!generated && !busy) back.replaceChildren(svg); }).catch(function () { status.textContent = preview.dataset.error; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

